// Bouton « Navigateur » de l'en-tête d'une conversation (02/10), à côté de « Fichiers » : rouvre
// le panneau Navigateur à tout moment, dès que la conversation existe. Le panneau affiche la
// session la plus récente (registreNavigateur) ; sans session, « L'assistant n'a pas encore ouvert
// de page » ; session expirée, « session terminée ». Toujours visible : le membre n'a pas à
// deviner si le navigateur a servi plus haut dans la conversation.
import { useConversationSidePanelContext } from "@app/components/assistant/conversation/ConversationSidePanelContext";
import { LIBELLES_NAVIGATEUR } from "@app/lib/compta/navigateur/libelles";
import { useIsMobile } from "@app/lib/swr/useIsMobile";
import { NAVIGATEUR_SIDE_PANEL_TYPE } from "@app/types/conversation_side_panel";
import { FilterChip, Globe01 } from "@dust-tt/sparkle";

export function BoutonNavigateur({
  conversationId,
}: {
  conversationId: string | null;
}) {
  const { currentPanel, isPanelClosing, togglePanel } =
    useConversationSidePanelContext();
  const isMobile = useIsMobile();

  if (!conversationId) {
    return null;
  }

  const libelle = LIBELLES_NAVIGATEUR.titre;
  return (
    <FilterChip
      // Sparkle (fusion du 16/10) : une puce a icone seule exige une infobulle, d'ou deux formes.
      {...(isMobile ? { tooltip: libelle } : { label: libelle })}
      icon={Globe01}
      variant="secondary"
      isSelected={
        currentPanel === NAVIGATEUR_SIDE_PANEL_TYPE && !isPanelClosing
      }
      onClick={() => togglePanel({ type: NAVIGATEUR_SIDE_PANEL_TYPE })}
    />
  );
}
